import React from 'react'
import About from './About'

const index = () => {
  return <About />
}

export default index
